import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/logos/Min_JV_Logo.png")